import React, {useContext} from "react";
import {Fade} from "react-reveal";
import "./Greeting.scss";
import Button from "../../components/button/Button";

import {
  greeting
} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function Greeting() {
  const {isDark} = useContext(StyleContext);
  if (!greeting.displayGreeting) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <h1 className={isDark ? "dark-mode greeting-text" : "greeting-text"}>
              Hi all, I'm <span className="blue-text">{greeting.username}</span>
            </h1>
            <p
              className={
                isDark ? "dark-mode greeting-text-p" : "greeting-text-p"
              }
              style={{marginInline: "auto"}}
            >
              {greeting.subTitle}
            </p>
            <div className="button-greeting-div">
              <Button text="Say Hello" href="mailto:contactvenkateshsundaram@gmail.com" />
              <Button
                text="About Me"
                href="#reachout"
                type="default"
              />
            </div>
          </div>
          <div className="browser-frame">
            <div className="browser-header">
              <div className="dot red"></div>
              <div className="dot yellow"></div>
              <div className="dot green"></div>
            </div>
            <div className="browser-content terminal-content">
              <div className="terminal-line">
                <span className="prompt">{greeting.username.toLowerCase()}@portfolio:~$</span>
                <span className="command">cat profile.json</span>
              </div>
              <div className="output">
{`{
  "name": "${greeting.username}",
  "role": "Software Professional",
  "status": "Ready to build something amazing!"
}`}
              </div>
              <div className="terminal-line">
                <span className="prompt">{greeting.username.toLowerCase()}@portfolio:~$</span>
                <span className="cursor"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}
